import React from "react";
import { Link } from "react-router-dom";

interface DashboardLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
}

function cn(...classes: Array<string | undefined>) {
  return classes.filter(Boolean).join(" ");
}

export const DashboardLink: React.FC<DashboardLinkProps> = ({ to, children, className }) => {
  return (
    <Link
      to={to}
      className={cn(
        "inline-flex items-center text-indigo-600 hover:text-indigo-700 dark:text-indigo-300 dark:hover:text-indigo-200 font-medium underline-offset-2 hover:underline",
        className
      )}
    >
      {children}
    </Link>
  );
};
